<template>
	<transition name="slide-fade" mode="out-in">
		<div class="contain" :style="`position: ${showRule || showShare?'fixed':''}`">
			<div class="unday-bg">
				<!-- 顶部 -->
				<div class="flex-row3">
					<div class="unday-share-btn" @click="clickShare()"><img src="../../../images/icon/share-dark.png"> 分享(+30积分)</div>
				</div>
				<div class="unday-order-tips">
					<div>参与有礼预约</div>
					<div>下一期会员日开始提前通知～</div>
					<div>还可获得全国人工价合集</div>
				</div>
				<!-- 中奖名单 -->
				<div class="win-list-title">截止当前已有{{infoData.reserveCount}}人预约</div>
				<div class="win-list">
					<div class="swiper-container win-list-container">
                        <div class="swiper-wrapper" >
                            <div class="swiper-slide">恭喜wa***x1 获得广材网会员奖励</div>
                            <div class="swiper-slide change-point" v-for="(item,index) in giftNameArr" :key="index">{{item.accountName | changeStar(4)}} 完成预约</div>
                        </div>
                    </div>
				</div>
				<div class="unday-order-btn" @click="clickOrder()">{{infoData.isHdReserve?'已预约':'有礼预约'}}</div>
				<div class="unday-value-title flex-row2">
					<div class="size-18 weight-b">我的积分</div>
					<div class="size-16 color-blue" @click="clickRule()">规则</div>
				</div>
	    		<!-- 进度条 -->
	    		<div class="day-bar-box">

    				<div class="day-value-tips" :style="`margin-left: ${barWidth-30}px`">
    					{{infoData.score}}
    					<div class="day-value-arrow"></div>
    				</div>
    				<div class="day-bar-bg">
    					<div class="day-bar" :style="`width: ${barWidth}px`"></div>
    				</div>
	    		</div>
	    		<div class="unday-medal-title flex-row1">
					<div class="size-18 weight-b">2021年成就勋章</div> 
					<div class="opacity-0">.</div>
					<div class="size-16 color-666">已获得{{historyList.length}}枚</div>
				</div>
    			<div class="unday-medal-block" >
    				<img v-for="(item,index) in memberDayList" :key="index" :class="[item.status==0?'opacity-3':'']" :src="require(`../../../images/memberDay/${item.year}${index*2+4>9?index*2+4:'0'+(index*2+4)}-${item.doneTimes==0 && item.status==2?'dark':'light'}.png`)">
    			</div>
				<div class="unday-history-title flex-row1" v-if="historyList.length!=0">
					<div class="size-18 weight-b">2021年会员日获奖记录</div>
				</div>
				<div class="unday-history-box" v-if="historyList.length!=0">
					<div class="unday-history-head flex-row1">
						<div class="width-64">序号</div>
						<div class="width-256">会员日</div>
					</div>
					<div class="unday-history-row flex-row1" v-for="(item,index) in historyList" :key="index">
						<div class="width-64 text-c">{{index+1}}</div>
						<div class="width-256 text-c">
							<div>{{item.hdName}}（{{item.joinTime}}）</div>
							<div class="change-point">获得{{item.prizeName}}</div>
						</div>
					</div>
				</div>
			</div>
				
			<!-- 一键领奖 -->
			<!-- <div class="mDI-bottom-bg"> -->
				<!-- <div class="btn-solid1 gift-btn" @click="confirm()">一键领奖</div> -->
				<!-- <div class="area-one-get" @click="confirm()">一键领奖</div> -->
				<!-- <div class="btn-solid1 gift-btned opacity-3" @click="confirm()" v-show="memberDayList.doneTimes>0">已领奖</div> -->
			<!-- </div> -->
	    	<!-- 活动锦囊弹框 -->
	    	<div class="m-fixed" v-show="showRule">
	    		<div class="day-fixedbox">
	    			<div class="flex-row2">
	    				<div class="width-48"></div>
	    				<div class="size-24">活动锦囊</div>
	    				<div class="day-fixed-close" @click="showRule=false"></div>
	    			</div>
	    			<div class="day-fixedbox-content">
	    				<div class="size-16 weight-b">积分规则</div>
	    				<div class="height-24"></div>
		    			<div class="size-16">一、活动说明</div>
		    			<div class="color-666">1、分享预约活动，被分享者成功参与可<span class="weight-b">获30积分</span>；</div>
		    			<div class="color-666">2、探索产品赢取积分，登录使用次数越多将赢取<span class="weight-b">越多积分</span>，全年不限时；</div>
		    			<div class="color-666">3、积分累计越高12月参与会员日活动；<span class="weight-b">中奖率越高</span>；</div>
		    			<div class="color-666">4、凡以不正当手段参与活动的用户，将会被终止参与活动，取消获奖资格；</div>
		    			<div class="height-24"></div>
		    			<div class="size-16">二、参与条件</div>
		    			<div class="color-666">截止当前广材信息权益有效期内会员</div>
		    			<div class="height-24"></div>
		    			<div class="color-666">本活动最终解释权归组织者所有。</div>
		    			<div class="height-24"></div>
	    			</div>
	    		</div>
	    	</div>
	    	<!-- 切换账号 -->
			<div class="m-fixed" v-show="showChangeAccount">
			    <div class="m-fixedbox width-80">
			        <div class="padding-lr-16">
			            <div class="flex-row2 height-72">
			                <span class="size-16 weight-b">提示</span>
			                <img class="width-24" @click="showChangeAccount=false" src="../../../images/icon/close.png">
			            </div>
			            <div>{{accountTips}}</div>
			        </div>
		            <div class="btn-fixed2-box">
		                <div class="btn-fixed2" v-show="changeBtn.indexOf('1')>-1" @click="untyingAccount()">登录其他账号</div>
		                <div class="btn-fixed2" v-show="changeBtn.indexOf('2')>-1" @click="login()">锁号登录</div>
		                <div class="btn-fixed2" v-show="changeBtn.indexOf('3')>-1" @click="untyingLock()">登录其他锁号</div>
		                <div class="btn-fixed2" v-show="changeBtn.indexOf('4')>-1" @click="login()">账号登录</div>
		                <div class="btn-fixed2" v-show="changeBtn.indexOf('5')>-1" @click="queryInfo(2)">确认</div>
		                <div class="btn-fixed2" v-show="changeBtn.indexOf('6')>-1" @click="queryInfo(1)">确认</div>
		            </div>
			    </div>
	    	</div>
	    	<!-- 分享 -->
	    	<div class="m-fixed" v-show="showShare" @click="showShare=false">
		      	<img class="margin-l-16 width-326" src="http://gcj-pub.oss-cn-beijing.aliyuncs.com/wechat/images/unday-share.png">
		    </div>
	    	<!-- 加载中 动画  @touchmove.prevent -->
	    	<loading v-show="showLoading"></loading>
		</div>	
	</transition>
</template>

<style lang="less" scoped>
@import "../../../style/variable.less";
@import "../../memberCenter/memberCenterIndex/style.less";
@import "./style.less";

</style>

<script>
module.exports = require("./index.js")
</script>